module.exports = __webpack_public_path__ + "static/media/shwstt.92fed62a.png";